import { stepNames, emailSubjects } from '../constants';

const titles = {
    [stepNames.purchaseCheck]: {
        [emailSubjects.question]:
            'Heeft je vraag <strong>betrekking op een aankoop</strong>?',
        [emailSubjects.complaint]:
            'Heeft je <strong>klacht betrekking op een aankoop</strong>?',
        [emailSubjects.change]:
            'Heeft je <strong>wijziging betrekking op een aankoop</strong>?',
    },
    [stepNames.customerMessage]: {
        [emailSubjects.question]: 'Wat is je <strong>vraag</strong>?',
        [emailSubjects.complaint]: 'Wat is je <strong>klacht</strong>?',
        [emailSubjects.change]: 'Wat is je <strong>wijziging</strong>?',
        [emailSubjects.compliment]: 'Wat is je <strong>compliment</strong>?',
        [emailSubjects.deletePersonalInfo]:
            '<strong>Verstuur</strong> je aanvraag',
        [emailSubjects.movePersonalInfo]:
            '<strong>Verstuur</strong> je aanvraag',
        [emailSubjects.viewPersonalInfo]:
            '<strong>Verstuur</strong> je aanvraag',
    },
};

export const getStepTitle = (step: string, subject: string) =>
    titles[step][subject] || '';
